import { classes } from 'html-classes';

import Typography, { VARIANT } from '~/components/isolated/Typography';
import { useGlobal } from '~/hooks/useGlobal';

import type { ReviewCardProps } from '../../interfaces';
import { formatCustomerName, formatReviewDate } from '../../utils';

import ReviewGallery from '../ReviewGallery';
import StarRating from '../StarRating';

import styles from './ReviewCard.module.scss';

const ReviewCard = ({
  review,
  showDivider = true,
  onMediaClick,
}: ReviewCardProps) => {
  const { isMobile } = useGlobal();

  const handleMediaClick = (index: number) => {
    if (review.media && onMediaClick) {
      onMediaClick(index, review.media);
    }
  };

  return (
    <div className={classes([styles.root, showDivider && styles.withDivider])}>
      <div className={styles.header}>
        <Typography
          variant={
            isMobile ? VARIANT['Text 300/Medium'] : VARIANT['Text 400/Semibold']
          }
          className={styles.authorName}
        >
          {formatCustomerName(review.customer)}
        </Typography>
        <Typography
          variant={VARIANT['Text 200/Medium']}
          className={styles.date}
        >
          {formatReviewDate(review.createdAt)}
        </Typography>
        <StarRating rating={review.mark} className={styles.rating} />
      </div>
      <Typography
        variant={
          isMobile
            ? VARIANT['Text 200/Regular High']
            : VARIANT['Text 300/Regular High']
        }
        as="p"
        className={styles.text}
      >
        {review.content}
      </Typography>
      {review.media && review.media.length > 0 && (
        <ReviewGallery
          media={review.media}
          className={styles.gallery}
          onMediaClick={handleMediaClick}
        />
      )}
    </div>
  );
};

export default ReviewCard;
